module.exports = __webpack_public_path__ + "img/approval copy.ca332e2e.svg";